import React from 'react';

import DualActionDialog from './../DualActionDialog';

const ChangePasswordDialog = (props) => {
  const {
    openDialog = false,
    onOpenChangePasswordDialog,
    onChangePassword,
    user,
    isSaving
  } = props;
  const handleClose = () => {
    onOpenChangePasswordDialog(false);
  };

  const handleSubmit = () => {
    onChangePassword(user.email);
  };

  return (
    <React.Fragment>
      <DualActionDialog
        open={openDialog}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        title="Change password"
        description="Are you sure you want to Change password?"
        actionButtonText="Yes"
        cancelButtonText="Cancel"
        showProgressBar={isSaving}
        errorMessage=""
      />
    </React.Fragment>
  );
};

export default ChangePasswordDialog;
